import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import GallerySection from '../components/home/GallerySection';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeFilter, setActiveFilter] = useState('all');

  // Gallery data with categories
  const galleryItems = [
    // Courses category
    { id: 1, src: '/images/gallery/courses/1.jpg', alt: 'STEM Robotics Course', category: 'courses' },
    { id: 2, src: '/images/gallery/courses/2.jpg', alt: 'Programming Session', category: 'courses' },
    { id: 3, src: '/images/gallery/courses/3.jpg', alt: 'Robotics Lab', category: 'courses' },
    { id: 4, src: '/images/gallery/courses/4.jpg', alt: 'Students Working on Projects', category: 'courses' },
    
    // Workshops category
    { id: 5, src: '/images/gallery/workshops/1.jpg', alt: 'Electronics Workshop', category: 'workshops' },
    { id: 6, src: '/images/gallery/workshops/2.jpg', alt: 'School Workshop', category: 'workshops' },
    { id: 7, src: '/images/gallery/workshops/3.jpg', alt: 'Hands-on Learning', category: 'workshops' },
    { id: 8, src: '/images/gallery/workshops/4.jpg', alt: 'STEM Workshop Activity', category: 'workshops' },
    
    // Events category
    { id: 9, src: '/images/gallery/events/1.jpg', alt: 'Robotics Competition', category: 'events' },
    { id: 10, src: '/images/gallery/events/2.jpg', alt: 'Awards Ceremony', category: 'events' },
    { id: 11, src: '/images/gallery/events/3.jpg', alt: 'Team Challenge', category: 'events' },
    { id: 12, src: '/images/gallery/events/4.jpg', alt: 'Exhibition Display', category: 'events' },
  ];

  // Filter gallery items based on active filter
  const filteredGallery = activeFilter === 'all' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === activeFilter);

  // Handle image click to open lightbox
  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden'; // Prevent scrolling when lightbox is open
  };

  // Close lightbox
  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto'; // Re-enable scrolling
  };

  return (
    <>
      <Helmet>
        <title>Gallery | STEM Labs</title>
        <meta name="description" content="Explore the STEM Labs photo gallery showcasing our robotics courses, workshops, and events" />
      </Helmet>
      {/* Hero/Header Section */}
      <div className="bg-gradient-to-r from-indigo-600 to-purple-500 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-extrabold mb-4 text-center animate-float">
            <span className="text-white">Our </span>
            <span className="text-pink-400">Gallery</span>
          </h1>
          <div className="w-32 h-1 bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400 rounded-full animate-pulse mx-auto mb-4"></div>
          <p className="text-white text-xl max-w-3xl mx-auto text-center">
            Explore images from our courses, workshops, and events
          </p>
        </div>
      </div>
      <GallerySection />
      
      {/* Lightbox */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 text-white bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-70 transition-colors"
            onClick={closeLightbox}
          >
            <FaTimes size={24} />
          </button>
          
          <div 
            className="max-w-6xl max-h-full" 
            onClick={e => e.stopPropagation()}
          >
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              className="max-w-full max-h-[80vh] object-contain"
            />
            <p className="text-white text-center mt-4">{selectedImage.alt}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default GalleryPage; 